export const QA_NAME_SUB_MENU_CONTEXT = 'submenu'
